import { render, staticRenderFns } from "./UrlParam.vue?vue&type=template&id=2035263f"
import script from "./UrlParam.vue?vue&type=script&lang=js"
export * from "./UrlParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports